import * as React from 'react'

import { Box, Button, Table, Text, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Diff, DiffFields } from 'modules/integrations_silae_api/lib/IncidenceSync/store'
import fieldTranslations from 'modules/integrations_silae_api/lib/fieldTranslations'

const SyncData = ({
  fields,
  onSync,
  syncing,
}: {
  fields: DiffFields
  onSync: () => void
  syncing: boolean
}) => {
  const [showSync, setShowSync] = useToggle(false)
  const fieldNames = Object.keys(fields)

  return (
    <>
      <Button onClick={setShowSync(!showSync)} type={showSync ? 'secondary' : 'primary'}>
        {showSync
          ? i18n.t('payroll_integrations.incidences.silae_api.sync_data.hide')
          : i18n.t('payroll_integrations.incidences.silae_api.sync_data.show')}
      </Button>
      {showSync && (
        <>
          <Text.Header2>
            {i18n.t('payroll_integrations.incidences.silae_api.sync_data.title')}
          </Text.Header2>
          <Box>{i18n.t('payroll_integrations.incidences.silae_api.sync_data.introduction')}</Box>
          <Table fullWidth>
            <Table.Head>
              <Table.Row>
                <Table.HeadCell>
                  {i18n.t('payroll_integrations.incidences.silae_api.sync_data.table.field')}
                </Table.HeadCell>
                <Table.HeadCell>Silae</Table.HeadCell>
                <Table.HeadCell>Factorial</Table.HeadCell>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {fieldNames.map((fieldName) => {
                const diff = fields[fieldName as keyof DiffFields] as Diff
                return (
                  <Table.Row key={fieldName}>
                    <Table.Cell>{fieldTranslations.t(fieldName)}</Table.Cell>
                    <Table.Cell>{diff.remote}</Table.Cell>
                    <Table.Cell>{diff.local}</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
          <Box>{i18n.t('payroll_integrations.incidences.silae_api.sync_data.question')}</Box>
          <Box>
            <Button onClick={onSync} disabled={syncing}>
              {i18n.t('payroll_integrations.incidences.silae_api.sync_data.submit')}
            </Button>
          </Box>
        </>
      )}
    </>
  )
}

export default SyncData
